var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M840,4920v-200H692.998c-90.996,0-175-6.001-217.998-15c-225-47.002-412.998-235-460-460 C-7.002,4140-7.002,580,15,475C62.002,250,250,62.002,475,15C580-7.002,4540-7.002,4645,15c225,47.002,412.998,235,460,460 c22.002,105,22.002,3665,0,3770c-47.002,225-235,412.998-460,460c-42.998,8.999-127.002,15-217.002,15H4280v200v200h-200h-200v-200 v-200H2560H1240v200v200h-200H840V4920z M840,4120v-200h200h200v200v200h1320h1320v-200v-200h200h200V4121v201.001l152.998-4.004 c144.004-2.998,156.006-3.999,190-27.998c21.006-13.999,50-42.998,65-63.999l27.002-38.999l2.998-274.004l2.998-272.998H2561.001 H400v252.998c0,139.004,5,268.003,10,289.004c12.998,43.999,81.001,115,123.999,126.997c17.002,5,93.003,10,168.999,10L840,4320 V4120z M4717.998,1887.001L4715,532.998l-27.002-38.994c-15-21.006-43.994-50-65-64.004l-37.002-25H2560H533.999l-36.997,25 c-21.001,14.004-50,42.998-65,64.004L405,532.998l-2.998,1354.004L400,3240h2160h2160L4717.998,1887.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M760,2620v-200h200h200v200v200H960H760V2620z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M1560,2620v-200h200h200v200v200h-200h-200V2620z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M2360,2620v-200h200h200v200v200h-200h-200V2620z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M3160,2620v-200h200h200v200v200h-200h-200V2620z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M3960,2620v-200h200h200v200v200h-200h-200V2620z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M760,1820v-200h200h200v200v200H960H760V1820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M1560,1820v-200h200h200v200v200h-200h-200V1820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M2360,1820v-200h200h200v200v200h-200h-200V1820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M3160,1820v-200h200h200v200v200h-200h-200V1820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M3960,1820v-200h200h200v200v200h-200h-200V1820z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M760,1020V820h200h200v200v200H960H760V1020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M1560,1020V820h200h200v200v200h-200h-200V1020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M2360,1020V820h200h200v200v200h-200h-200V1020z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M3160,1020V820h200h200v200v200h-200h-200V1020z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackCalendar);
export default __webpack_public_path__ + "static/media/pack_calendar.8cee6bf23bea6f649cdaf1d85dda31f4.svg";
export { ForwardRef as ReactComponent };